import { error } from './chunk-GYQOUG5R.js';
import { cache } from 'react';

var $input = Symbol("Input");
function createSearchParamsCache(parsers) {
  const getCache = cache(() => ({
    searchParams: {}
  }));
  function parse(searchParams) {
    const c = getCache();
    if (Object.isFrozen(c.searchParams)) {
      if (searchParams === c[$input]) {
        return all();
      }
      throw new Error(error(501));
    }
    for (const key in parsers) {
      const parser = parsers[key];
      c.searchParams[key] = parser.parseServerSide(searchParams[key]);
    }
    c[$input] = searchParams;
    return Object.freeze(c.searchParams);
  }
  function all() {
    const { searchParams } = getCache();
    if (Object.keys(searchParams).length === 0) {
      throw new Error(error(500));
    }
    return searchParams;
  }
  function get(key) {
    const { searchParams } = getCache();
    const entry = searchParams[key];
    if (typeof entry === "undefined") {
      throw new Error(
        error(500) + `
  in get(${String(key)})`
      );
    }
    return entry;
  }
  return { parse, get, all };
}

export { createSearchParamsCache };
